/* __next_internal_client_entry_do_not_use__ LoggedInCategoryPageLoadingSkeleton auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, HorizontalLine, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React, { Fragment } from "react";
import styled, { css } from "styled-components";
import { GhostBlock } from "@faire/retailer/components/GhostLoading/GhostBlock";
import { GhostText } from "@faire/retailer/components/GhostLoading/GhostTypography";
import { LoadingProductTileSkeleton } from "@faire/retailer/components/LoadingProductTileSkeleton/LoadingProductTileSkeleton";
import { MAX_CONTENT_WIDTH, MAX_WIDE_SCREEN_CONTENT_WIDTH } from "@faire/retailer/features/Marketplace/styleConsts";
import { OuterResultsContentWrapper } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/CategoryPageCommonStyles";
import { ElevatedContentWrapper } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/LoggedInCategoryPageStyles";
var FILTER_PROPS = {
    $height: "40px",
    $borderRadius: "20px"
};
var NUM_TILES = {
    mobile: 4,
    tablet: 12,
    desktopAndAbove: 16
};
var NUM_LONG_FILTERS = {
    mobile: 1,
    tablet: 3,
    desktopAndAbove: 4
};
var NUM_FILTER_SECTIONS = 3;
var NUM_SIDENAV_CATEGORIES = 10;
export var LoggedInCategoryPageLoadingSkeleton = function(param) {
    var isFullWidthCategoryPage = param.isFullWidthCategoryPage;
    return /*#__PURE__*/ _jsx(Container, {
        "data-test-id": "logged-in-category-page-loading-skeleton",
        children: /*#__PURE__*/ _jsxs(ElevatedContentWrapper, {
            $maxWidth: isFullWidthCategoryPage ? MAX_WIDE_SCREEN_CONTENT_WIDTH : MAX_CONTENT_WIDTH,
            children: [
                /*#__PURE__*/ _jsx(GhostBlock, {
                    $width: getSpacing(160),
                    $height: getSpacing("5x")
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    size: "1x"
                }),
                /*#__PURE__*/ _jsx(GhostBlock, {
                    $width: "50%",
                    $height: getSpacing(20)
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: {
                        mobileAndAbove: "2x",
                        desktopAndAbove: "4x"
                    }
                }),
                /*#__PURE__*/ _jsx(GhostBlock, {
                    $width: "100%",
                    $height: getSpacing(280)
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: {
                        mobileAndAbove: "4x",
                        desktopAndAbove: "5x"
                    }
                }),
                /*#__PURE__*/ _jsxs(ContentContainer, {
                    children: [
                        /*#__PURE__*/ _jsxs(SidebarContainerWithFilters, {
                            children: [
                                /*#__PURE__*/ _jsx(GhostText, {}),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    width: "2x"
                                }),
                                /*#__PURE__*/ _jsx(Column, {
                                    style: {
                                        paddingLeft: 16
                                    },
                                    children: Array.from({
                                        length: NUM_SIDENAV_CATEGORIES
                                    }).map(function(_, index) {
                                        return /*#__PURE__*/ _jsxs(Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(FilterPlaceholder, {}),
                                                /*#__PURE__*/ _jsx(Spacer, {
                                                    width: "2x"
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ _jsx(HorizontalLine, {}),
                                Array.from({
                                    length: NUM_FILTER_SECTIONS
                                }).map(function(_, index) {
                                    return /*#__PURE__*/ _jsxs(Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Spacer, {
                                                width: "3x"
                                            }),
                                            /*#__PURE__*/ _jsx(GhostText, {}),
                                            /*#__PURE__*/ _jsx(Spacer, {
                                                width: "3x"
                                            }),
                                            /*#__PURE__*/ _jsx(HorizontalLine, {})
                                        ]
                                    }, index);
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(OuterResultsContentWrapper, {
                            children: [
                                /*#__PURE__*/ _jsx(GhostBlock, {
                                    $width: getSpacing(160),
                                    $height: getSpacing("5x")
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    size: "1x"
                                }),
                                /*#__PURE__*/ _jsx(GhostBlock, {
                                    $width: "50%",
                                    $height: getSpacing(20)
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: {
                                        mobileAndAbove: "2x",
                                        desktopAndAbove: "4x"
                                    }
                                }),
                                /*#__PURE__*/ _jsxs(FilterRow, {
                                    children: [
                                        /*#__PURE__*/ _jsx(GhostBlock, _object_spread({
                                            $width: "44px"
                                        }, FILTER_PROPS)),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            width: "2x"
                                        }),
                                        /*#__PURE__*/ _jsx(GhostBlock, _object_spread({
                                            $width: "44px"
                                        }, FILTER_PROPS)),
                                        Array.from({
                                            length: NUM_LONG_FILTERS["desktopAndAbove"]
                                        }).map(function(_, index) {
                                            return /*#__PURE__*/ _jsxs(Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx(Spacer, {
                                                        width: "2x"
                                                    }),
                                                    /*#__PURE__*/ _jsx(LongFilter, _object_spread_props(_object_spread({}, FILTER_PROPS), {
                                                        index: index
                                                    }))
                                                ]
                                            }, index);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: "2x"
                                }),
                                /*#__PURE__*/ _jsx(TileGrid, {
                                    $isFullWidth: isFullWidthCategoryPage,
                                    children: Array.from({
                                        length: NUM_TILES["desktopAndAbove"]
                                    }).map(function(_, index) {
                                        return /*#__PURE__*/ _jsx(LoadingProductTileSkeleton, {}, index);
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var Container = styled(Column).withConfig({
    componentId: "sc-d3ed199d-0"
})([
    "padding:",
    ";"
], getSpacing("4x", 0));
var TileGrid = styled.div.withConfig({
    componentId: "sc-d3ed199d-1"
})([
    "display:grid;grid-gap:",
    ";",
    "{grid-template-columns:repeat(2,2fr);}",
    "{grid-template-columns:repeat(4,4fr);}",
    ""
], getSpacing("2x"), responsiveMediaQueries.mobile, responsiveMediaQueries.tabletAndAbove, function(props) {
    return props.$isFullWidth ? css([
        "",
        "{grid-template-columns:repeat(5,5fr);}"
    ], responsiveMediaQueries.xLargeAndAbove) : undefined;
});
var hiddenStyles = css([
    "position:absolute;z-index:-1;"
]);
var FilterRow = styled(Row).withConfig({
    componentId: "sc-d3ed199d-2"
})([
    "overflow-x:hidden;"
]);
var LongFilter = styled(GhostBlock).attrs({
    $width: "120px"
}).withConfig({
    componentId: "sc-d3ed199d-3"
})([
    "",
    "{",
    "}",
    "{",
    "}"
], responsiveMediaQueries.mobile, function(param) {
    var index = param.index;
    return index > NUM_LONG_FILTERS["mobile"] - 1 ? hiddenStyles : "";
}, responsiveMediaQueries.tablet, function(param) {
    var index = param.index;
    return index > NUM_LONG_FILTERS["tablet"] - 1 ? hiddenStyles : "";
});
var ContentContainer = styled(Row).withConfig({
    componentId: "sc-d3ed199d-4"
})([
    "padding-top:12px;height:100%;"
]);
// eslint-disable-next-line @faire/prefer-slate-attrs -- use ResponsiveContentV2
var SidebarContainerWithFilters = styled(Column).attrs({
    flex: "0 0 228px"
}).withConfig({
    componentId: "sc-d3ed199d-5"
})([
    "margin-right:",
    ";&&&{",
    "{display:none;}}"
], getSpacing("6x"), responsiveMediaQueries.tabletAndBelow);
var FilterPlaceholder = styled(GhostText).withConfig({
    componentId: "sc-d3ed199d-6"
})([
    "padding:10px;"
]);
